import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import cardsReducer from '../features/cards/cardsSlice';
import uiReducer from '../features/ui/uiSlice';
import fileUrlsReducer from '../features/fileUrlsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    cards: cardsReducer,
    ui: uiReducer,
    fileUrls: fileUrlsReducer,
  },
});